import React from "react";
import { useEffect } from "react";

const NoResultsByFilters = () => {
  useEffect(() => {
    // Get content configured from aem by element id coveo-no-result-filter-container
    const noResultFilterElm = document.getElementById(
      "coveo-no-result-filter-container"
    );
    const appendNewNoResultElm = document.getElementById(
      "coveo-no-result-content-filter"
    );

    // Append content to the element id coveo-no-result-content on coveo
    if (noResultFilterElm && appendNewNoResultElm) {
      appendNewNoResultElm.appendChild(noResultFilterElm);
      return () => {
        const noResultFilterContainerElm = document.getElementById(
          "coveo-no-result-by-filter"
        );
        const appendNewNoResultElm1 = document.getElementById(
          "coveo-no-result-filter-container"
        );
        if (noResultFilterContainerElm && appendNewNoResultElm1) {
          noResultFilterContainerElm.appendChild(appendNewNoResultElm1);
        }
      };
    }
  });
  return <div id="coveo-no-result-content-filter"></div>;
}

export default NoResultsByFilters;
